export default __webpack_public_path__ + "static/media/UAE-Consumer.138b8077.png";